import LifecareStudioAgeYearCell from './LifecareStudioAgeYearCell';
import LifecareStudioNumberInput from './LifecareStudioNumberInput';
import LifecareStudioRowMoveMenu from './LifecareStudioRowMoveMenu';
import XAutoGrowTextarea from '../common/XAutoGrowTextarea';
import {
  dangerInlineButtonClasses,
  rowActionsCellClasses,
  tableBodyCellClasses,
  tableCellMinHeight,
  tableTextareaClasses,
  totalsCellClasses,
} from './lifecareStudioClasses';
import { formatCurrency } from '../../utils/lifecarePlanUtils';

const AGE_YEAR_COLUMN_KEY = 'ageYear';

const TABLE_COLUMNS = [
  { field: 'item', type: 'text' },
  { field: AGE_YEAR_COLUMN_KEY, type: 'ageYear' },
  { field: 'frequencyPerYear', type: 'number', step: '1' },
  { field: 'frequencyComment', type: 'text' },
  { field: 'purpose', type: 'textarea' },
  { field: 'unitCost', type: 'number', step: 'any' },
];

// text and textarea cells both render an auto-growing textarea so long values wrap into
// view instead of scrolling inside a fixed-height box; the text ones stay single-line.
const renderCellInput = ({ column, row, onFieldChange }) => {
  if (column.type === 'ageYear') {
    return <LifecareStudioAgeYearCell row={row} onFieldChange={onFieldChange} />;
  }
  if (column.type === 'number') {
    return (
      <LifecareStudioNumberInput
        value={row?.[column.field]}
        step={column.step}
        onValueChange={(value) => onFieldChange({ field: column.field, value })}
      />
    );
  }
  return (
    <XAutoGrowTextarea
      className={tableTextareaClasses}
      minHeight={tableCellMinHeight}
      singleLine={column.type === 'text'}
      value={row?.[column.field] ?? ''}
      onChange={(event) =>
        onFieldChange({ field: column.field, value: event.target.value })
      }
    />
  );
};

const LifecareStudioTableRow = ({ row, moveTargets, onFieldChange, onRemove, onMoveRow }) => (
  <tr>
    {TABLE_COLUMNS.map((column) => (
      <td key={column.field} className={tableBodyCellClasses}>
        {renderCellInput({ column, row, onFieldChange })}
      </td>
    ))}
    <td className={`${tableBodyCellClasses} ${totalsCellClasses}`}>
      {formatCurrency(row?.lifetimeCost)}
    </td>
    <td className={tableBodyCellClasses}>
      <div className={rowActionsCellClasses}>
        <button
          type="button"
          className={dangerInlineButtonClasses}
          onClick={onRemove}
          aria-label="Remove row"
        >
          <i className="fa fa-trash" />
        </button>
        <LifecareStudioRowMoveMenu moveTargets={moveTargets} onMoveRow={onMoveRow} />
      </div>
    </td>
  </tr>
);

export const LIFECARE_TABLE_COLUMN_LABELS = [
  'Item',
  'Age / Year',
  'Frequency / Year',
  'Frequency',
  'Purpose',
  'Unit Cost',
  'Lifetime Cost',
  '',
];

export default LifecareStudioTableRow;
